import React from "react";
import { connect } from 'react-redux';
import { isDefined, cloneArray } from '../../../utils';
import AddItemIcon from '../../../icons/AddItemIcon';
import FreeTextQuestionIcon from '../../../icons/v3/FreeTextQuestionIcon';
import MultipleChoiceQuestionIcon from '../../../icons/v3/MultipleChoiceQuestionIcon';
import OpinionScaleQuestionIcon from '../../../icons/v3/OpinionScaleQuestionIcon';
import YesNotQuestionIcon from '../../../icons/v3/YesNotQuestionIcon';

import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import SelectLikertScaleType from './SelectLikertScaleType';
import RadioOptions from '../utils/RadioOptions';

class QuestionEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentQuestion: {},
            showLikertScalePopUp: false,
            chosenLikertScaleType: {},
        };

        this.updateQuestionName = this.updateQuestionName.bind(this);
        this.updateQuestionMaxPoints = this.updateQuestionMaxPoints.bind(this);
        this.updateSectionName = this.updateSectionName.bind(this);        
        
        this.updateQuestionDisplayText = this.updateQuestionDisplayText.bind(this);
        this.updateChoiceValue = this.updateChoiceValue.bind(this);
        this.updatePointValue = this.updatePointValue.bind(this);        
        this.removeChoice = this.removeChoice.bind(this);
        this.addChoice = this.addChoice.bind(this);
        this.onSave = this.onSave.bind(this);

        this.showLikertScalePopUp = this.showLikertScalePopUp.bind(this);
        this.closeLikertScalePopUp = this.closeLikertScalePopUp.bind(this);

        this.getCreateResponsesNode = this.getCreateResponsesNode.bind(this);
        this.getResponsesNode = this.getResponsesNode.bind(this);
        this.getResponseNode = this.getResponseNode.bind(this);
        this.getQuestionTypeAndIconNode = this.getQuestionTypeAndIconNode.bind(this);
    }

    componentDidMount() {
        const
            {
                currentQuestion
            } = this.props;
        let updateCurrentQuestion = currentQuestion;
        this.setState({ currentQuestion: updateCurrentQuestion });
    }

    updateQuestionName({ target }) {
        let updateCurrentQuestion = this.state.currentQuestion;
        updateCurrentQuestion.name = target.value;
        this.setState({ currentQuestion: updateCurrentQuestion });
    }

    updateSectionName({ target }) {
        let updateCurrentQuestion = this.state.currentQuestion;
        updateCurrentQuestion.sectionName = target.value;
        this.setState({ currentQuestion: updateCurrentQuestion });
    }

    updateQuestionMaxPoints({ target }) {
        let updateCurrentQuestion = this.state.currentQuestion;
        updateCurrentQuestion.maxPoints = target.value;
        this.setState({ currentQuestion: updateCurrentQuestion });
    }    

    updateQuestionDisplayText({ target }) {
        let updateCurrentQuestion = this.state.currentQuestion;
        updateCurrentQuestion.displayText = target.value;
        this.setState({ currentQuestion: updateCurrentQuestion });
    }

    updateChoiceValue({ target }) {
        let updateCurrentQuestion = this.state.currentQuestion;
        var choiceToEdit = updateCurrentQuestion.choices.find(c => c.id == target.id);
        choiceToEdit.value = target.value;
        this.setState({ currentQuestion: updateCurrentQuestion });
    }

    updatePointValue({ target }) {
        let updateCurrentQuestion = this.state.currentQuestion;
        var choiceToEdit = updateCurrentQuestion.choices.find(c => c.id == target.id);
        choiceToEdit.pointValue = target.value;
        this.setState({ currentQuestion: updateCurrentQuestion });
    }

    removeChoice(choice) {
        let updateCurrentQuestion = this.state.currentQuestion;
        updateCurrentQuestion.choices = updateCurrentQuestion.choices.filter(c => c.id != choice.id);
        this.setState({ currentQuestion: updateCurrentQuestion });
    }

    addChoice() {
        let updateCurrentQuestion = this.state.currentQuestion;
        const maxId = Math.max(...updateCurrentQuestion.choices.map(o => o.id));
        updateCurrentQuestion.choices.push(
            {
                id: maxId + 1,
                value: '',
                pointValue: ''
            }
        );
        this.setState({ currentQuestion: updateCurrentQuestion });
    }

    showLikertScalePopUp() {
        this.setState({ showLikertScalePopUp: true });
    }

    closeLikertScalePopUp(likertScaleType) {
        this.setState({
            showLikertScalePopUp: false,
        });
        if (isDefined(likertScaleType)) {
            let updateCurrentQuestion = this.state.currentQuestion;
            updateCurrentQuestion.choices = cloneArray(likertScaleType.choices);
            this.setState({
                chosenLikertScaleType: likertScaleType,
                currentQuestion: updateCurrentQuestion
            });

        }
    }

    getQuestionTypeAndIconNode() {
        const
            {
                currentQuestion
            } = this.props;
        let icon;
        switch (currentQuestion.type.value) {
            case 'Multiple Answer':
                icon = <MultipleChoiceQuestionIcon />
                break;
            case 'Opinion Scale':
                icon = <OpinionScaleQuestionIcon />
                break;
            case 'Yes/No':
                icon = <YesNotQuestionIcon />
                break;
            case 'Free Text':
                icon = <FreeTextQuestionIcon />
                break;
            default:
        }
        return (
            <div className="flex-container-start">
                {icon}
                <div style={{ marginLeft: '6px' }}>{currentQuestion.type.value}</div>
            </div>);
    }

    getResponseNode(choice) {
        return (
            <div key={choice.id} className="flex-container-start" style={{ margin: '5px 0' }}>
                <div style={{ margin: '0 5px' }}>
                    <HighlightOffIcon onClick={() => this.removeChoice(choice)} />
                </div>
                <input
                    type="text"
                    id={choice.id}
                    value={choice.value}
                    onChange={this.updateChoiceValue}
                    className="text-input"
                    style={{ width: '325px', height: '50px', padding: '0 20px' }} />
                
                <input
                    type="text"
                    id={choice.id}
                    value={choice.pointValue}
                    onChange={this.updatePointValue}
                    className="text-input"
                    placeholder="Points"
                    style={{ marginLeft: '10px', width: '65px', height: '50px', padding: '0 20px' }} />
                
            </div>)
    }

    getResponsesNode() {
        if (this.state.currentQuestion && this.state.currentQuestion.choices && Array.isArray(this.state.currentQuestion.choices)) {
            const choices = this.state.currentQuestion.choices.map(c => this.getResponseNode(c));
            return (<div>
                {choices}
                <div className="flex-container-start" style={{ margin: '10px 0' }} onClick={() => this.addChoice()} >
                    <div style={{ marginRight: '5px' }} >
                        <AddItemIcon />
                    </div>
                    <div>Add Question</div>
                </div>
            </div>)
        }
    }

    getCreateResponsesNode() {
        const
            {
                currentQuestion
            } = this.props;
        let createResponseButtons;
        const options = [
            { id: 1, value: 'Manually', isDefaultSelected: true },
            { id: 2, value: 'Use Likert Scale', onClick: this.showLikertScalePopUp }]

        switch (currentQuestion.type.value) {
            case 'Multiple Answer':
                createResponseButtons = (
                    <div>
                        <h1 style={{ margin: '10px 0px 20px 0' }}>Add response</h1>
                    </div>);
                break;
            case 'Opinion Scale':
                createResponseButtons = (
                    <>
                        <h1 style={{ margin: '10px 0px 20px 0' }}>Add response</h1>
                        <div style={{ margin: '20px 0' }}>
                            <RadioOptions options={options} />
                        </div>
                    </>)
                break;
            case 'Yes/No':
                createResponseButtons = (<div>
                    <h1 style={{ margin: '10px 0px 20px 0' }}>Add response</h1>
                </div>);
                break;
            case 'Free Text':
                break;
            default:
        }

        const responses = this.getResponsesNode();
        return (<div style={{ padding: '20px 10px' }} >
            {createResponseButtons}
            {responses}
        </ div>);
    }

    onSave() {
        const
            {
                onSave
            } = this.props;
        let questionToSave = this.state.currentQuestion;
        onSave(questionToSave);
    }

    render() {
        const responsesNode = this.getCreateResponsesNode();
        const questionTypeAndIconNode = this.getQuestionTypeAndIconNode();
        const saveQuestionButton = (
            <div className="v3-button agent-view-interactions" onClick={this.onSave}>
                Save Question
            </div>);
        return (<div>
            <div style={{ marginBottom: '10px' }}>
                {questionTypeAndIconNode}
            </div>
            <div style={{ marginBottom: '10px' }}>
                <input
                    type="text"
                    value={this.state.currentQuestion.sectionName}
                    placeholder="Section"
                    onChange={this.updateSectionName}
                    className="text-input"
                    style={{ width: '325px', height: '50px', padding: '0 20px' }} />
            </div>
            <div style={{ margin: '10px 0' }}>
                <input
                    type="text"
                    value={this.state.currentQuestion.name}
                    placeholder="Question Name"
                    onChange={this.updateQuestionName}
                    className="text-input"
                    style={{ width: '325px', height: '50px', padding: '0 20px' }} />
                <input
                    type="text"
                    value={this.state.currentQuestion.maxPoints}
                    placeholder="Points"
                    onChange={this.updateQuestionMaxPoints}
                    className="text-input"
                    style={{ marginLeft: '10px', width: '83px', height: '50px', padding: '0 20px' }} />
            </div>
            <div style={{ margin: '10px 0' }}>
                <input
                    type="text"
                    value={this.state.currentQuestion.displayText}
                    placeholder="Question Display Text"
                    onChange={this.updateQuestionDisplayText}
                    className="text-input"
                    style={{ width: '-webkit-fill-available', height: '50px', padding: '0 20px' }} />
            </div>
            <div style={{ background: '#FDF9FB' }}>
                {responsesNode}
            </div>
            {saveQuestionButton}
            {this.state.showLikertScalePopUp &&
                <div className="modal displayBlock" >
                    <div className="modal-content modal-content-selectLikertScale">
                        <SelectLikertScaleType
                            onClose={this.closeLikertScalePopUp} />
                    </div>
                </div>}
        </div>);
    };
}

const select = state => ({});
export default connect(select)(QuestionEditor);

